import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constant } from '../common/constant';
import { Observable } from 'rxjs';
import { AccountConfiguration } from '../models/accountConfig.model';
import { AddPremiseHierarchyModel } from '../models/premise.model';
import { PlanMaster } from '../models/planMaster.model';

@Injectable()
export class AdministratorService {

    constructor(private readonly http: HttpClient) {
    }

    getAllFeatures() {
        const url = Constant.REST_URL + Constant.ACCOUNTCONFIGURATION + Constant.GET_ALL_FEATURE;
        return this.http.get(url);
    }

    accountConfigurationRegistration(details): Observable<AccountConfiguration> {
        const url = Constant.REST_URL + Constant.ACCOUNTCONFIGURATION + Constant.REGISTER_ACCOUNT_CONFIGURATION;
        return this.http.post<AccountConfiguration>(url , details);
    }

    getAccountConfiguration(id) {
        const url = Constant.REST_URL + Constant.ACCOUNTCONFIGURATION + Constant.GET_CONFIGURATION_BY_ACCOUNT_ID + '?accountId=' + id;
        return this.http.get(url);
    }

    registerFieldConfiguration(details) {
        const url = Constant.REST_URL + Constant.ACCOUNTCONFIGURATION + Constant.REGISTER_FIELD_CONFIGURATION;
        return this.http.post(url , details);
    }

    getGuestFieldConfiguration(id) {
        const url = Constant.REST_URL + Constant.ACCOUNTCONFIGURATION + Constant.GET_FIELD_CONFIGURATION + '?accountId=' + id;
        return this.http.get(url);
    }

    getAllPlanMaster(params, searchBy) {
        const url = Constant.REST_URL + Constant.ACCOUNTCONFIGURATION + Constant.GET_ALL_PLAN_MASTER
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy;
        return this.http.get(url);
    }

    registerPlanMaster(details): Observable<PlanMaster> {
        const url = Constant.REST_URL + Constant.ACCOUNTCONFIGURATION + Constant.CREATE_PLAN_MASTER;
        return this.http.post<PlanMaster>(url , details);
    }

    getPlanMasterById(id) {
        const url = Constant.REST_URL + Constant.ACCOUNTCONFIGURATION + Constant.GET_PLAN_BY_ID + '?planId=' + id;
        return this.http.get(url);
    }

    getGuestGroupCfg(id) {
        const url = Constant.REST_URL + Constant.ACCOUNTCONFIGURATION + Constant.GET_FIELD_CONFIGURATION_FOR_MOBILE + '?accountId=' + id;
        return this.http.get(url);
    }

    checkLinkExpire(accountId,uniqueCode) {
        const url = Constant.REST_URL + Constant.SELFSERVICE + Constant.CHECK_LINK_EXPIRE + '?uniqueCode=' + uniqueCode+'&accountId='+accountId;
        return this.http.get(url);
    }

    getSelfServiceLinkByCode(accountId, uniqueCode) {
        const url = Constant.REST_URL + Constant.SELFSERVICE + '/get_link_details?uniqueCode=' + uniqueCode + '&accountId=' + accountId;
        return this.http.get(url);
    }

    createSelfGuest(details): Observable<any> {
        const url = Constant.REST_URL + Constant.SELFSERVICE + Constant.CREATE_SELF_GUEST;
        return this.http.post<any>(url , details);
    }

    getAccountOCRKey(params, searchBy) {
        const url = Constant.REST_URL + Constant.ACCOUNTCONFIGURATION + Constant.GET_ACCOUNT_OCR_KEY
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy;
        return this.http.get(url);
    }

    registerOCRAPIKey(details): Observable<any> {
        const url = Constant.REST_URL + Constant.ACCOUNTCONFIGURATION + Constant.REGISTER_OCR_KEY;
        return this.http.post<any>(url , details);
    }

    generateOCRKey(accountId: number, days?: number, maxRequests?: number): Observable<any> {
        let url = Constant.REST_URL + Constant.GENERATE_OCR_KEY + `?accountId=${accountId}`;
        if (days) url += `&days=${days}`;
        if (maxRequests) url += `&maxRequests=${maxRequests}`;
        return this.http.post<any>(url, {});
    }

    renewOCRKey(accountId: number, days?: number, maxRequests?: number): Observable<any> {
        let url = Constant.REST_URL + Constant.RENEW_OCR_KEY + `?accountId=${accountId}`;
        if (days) url += `&days=${days}`;
        if (maxRequests) url += `&maxRequests=${maxRequests}`;
        return this.http.put<any>(url, {});
    }

    getOCRKeyUsage(accountId: number): Observable<any> {
        const url = Constant.REST_URL + Constant.GET_OCR_KEY_USAGE + `?accountId=${accountId}`;
        return this.http.get(url);
    }

    getOcrStats(): Observable<any> {
        const url = Constant.REST_URL + Constant.GET_OCR_STATS;
        return this.http.get(url);
    }

    getEligibleUsersForBinding(accountId) {
        const url = Constant.REST_URL + Constant.BOUND_DEVICE + Constant.GET_ELIGIBLE_USERS + '/' + accountId;
        return this.http.get(url);
    }

    grantAccess(details) {
        const url = Constant.REST_URL + Constant.BOUND_DEVICE + Constant.GRANT_ACCESS;
        return this.http.post<any>(url, details);
    }

    grantAccessBulk(details) {
        const url = Constant.REST_URL + Constant.BOUND_DEVICE + Constant.GRANT_ACCESS_BULK;
        return this.http.post<any>(url, details);
    }

    revokeAccess(details) {
        const url = Constant.REST_URL + Constant.BOUND_DEVICE + Constant.REVOKE_ACCESS;
        return this.http.post<any>(url, details);
    }

    revokeAccessBulk(details) {
        const url = Constant.REST_URL + Constant.BOUND_DEVICE + Constant.REVOKE_ACCESS_BULK;
        return this.http.post<any>(url, details);
    }

    getTotalBoundDevices(accountId) {
        const url = Constant.REST_URL + Constant.BOUND_DEVICE + Constant.TOTAL_BOUND + '/' + accountId;
        return this.http.get(url);
    }

    checkMobileBindingLicense(accountId) {
        const url = Constant.REST_URL + Constant.BOUND_DEVICE + '/check-license/' + accountId;
        return this.http.get(url);
    }

    getMobileBindingLicense(accountId) {
        const url = Constant.REST_URL + Constant.ACCOUNTCONFIGURATION + Constant.MOBILE_BINDING_LICENSE + '?accountId=' + accountId;
        return this.http.get(url);
    }

    updateMobileBindingLicense(details) {
        const url = Constant.REST_URL + Constant.ACCOUNTCONFIGURATION + Constant.MOBILE_BINDING_LICENSE;
        return this.http.post(url, details);
    }

    sendSystemNotification(details): Observable<any> {
        const url = Constant.REST_URL + Constant.SYSTEM_NOTIFICATION + Constant.SEND_SYSTEM_NOTIFICATION;
        return this.http.post(url, details);
    }

    saveSystemNotification(details): Observable<any> {
        const url = Constant.REST_URL + Constant.SYSTEM_NOTIFICATION + Constant.SAVE_SYSTEM_NOTIFICATION;
        return this.http.post(url, details);
    }

    getAllSystemNotifications(params): Observable<any> {
        const url = Constant.REST_URL + Constant.SYSTEM_NOTIFICATION + Constant.GET_ALL_SYSTEM_NOTIFICATION
        + '?page='
        + (params.currentPage - 1) + '&size=' + params.itemsPerPage;
        return this.http.get(url);
    }

    getAllAccountsForNotification(): Observable<any> {
        const url = Constant.REST_URL + Constant.SYSTEM_NOTIFICATION + '/get_accounts';
        return this.http.get(url);
    }

    getRecipients(accountId, role): Observable<any> {
        let url = Constant.REST_URL + Constant.SYSTEM_NOTIFICATION + Constant.GET_RECIPIENTS;
        if (accountId) {
            url += '?accountId=' + accountId;
        } else {
            url += '?accountId=null';
        }
        if (role) {
            url += '&role=' + role;
        }
        return this.http.get(url);
    }

}
